import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface ButtonIProps {
  $buttonColor: string;
  $textColor: string;
}

export const IntrobannerModal = styled.div`
  ${mixin.flex({ direction: 'column' })};
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  .content {
    position: relative;
    width: 100%;
    height: 100%;

    .img {
      width: 100%;
      height: 100%;
    }

    .area-btn {
      position: absolute;
      bottom: 40px;
      width: 100%;
      padding: 0 20px;
      ${mixin.flex({ wrap: 'wrap', justify: 'flex-start' })};
      gap: 6px;
    }
  }

  .modal-today-close-btn {
    margin-top: auto;
    border-top: 1px solid #eee;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .content {
      .area-btn {
        bottom: ${mixin.pxToVw('40')};
        padding: ${mixin.pxToVw('0 20')};
        column-gap: ${mixin.pxToVw('6')};

        .btn {
          height: ${mixin.pxToVw('50')};
          font-size: ${mixin.pxToVw('15')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    position: relative;
    top: auto;
    left: auto;
    width: 450px;
    height: 672px;

    .content {
      .area-btn {
        width: 320px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
`;

export const Box = styled.span<ButtonIProps>`
  display: contents;

  .btn {
    width: 100%;
    max-width: 100%;
    height: 50px;
    padding: 0 40px;
    font-size: 15px;
    font-weight: 500;
    line-height: 130%;
    background-color: ${props => props.$buttonColor || '#000'};
    color: ${props => props.$textColor || '#fff'};
  }

  &:not(:only-child) .btn {
    max-width: calc(50% - 3px);
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn {
      height: ${mixin.pxToVw('50')};
      padding: ${mixin.pxToVw('0 40')};
      font-size: ${mixin.pxToVw('15')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .btn {
      max-width: 280px;
      height: 40px;
      padding: 0 20px;
      font-size: 14px;
    }

    &:not(:only-child) .btn {
      max-width: 137px;
    }
  }
`;
